<template>
  <div :class="`${el}__step3`">
    <InViewAnimation>
      <Headline :staticClass="`${el}__headline`" slot="1" size="xs" responsive centered>
        {{ $t('intro.step3.headline') }}
      </Headline>

      <BaseRadio
        slot="2"
        id="step3-1"
        name="step3"
        :label="$t('intro.step3.radio1.label')"
        checkmark
        advanced
        :class="`${el}__input`"
        :checked="dependentPerson === 'me'"
        @input="onChange('me')"
        tabindex="0"
        @keyup.enter.native="onChange('me')"
        @keyup.space.native="onChange('me')"
        role="radio"
        :aria-checked="dependentPerson === 'me'"
      />

      <BaseRadio
        slot="3"
        id="step3-2"
        name="step3"
        :label="$t('intro.step3.radio2.label')"
        checkmark
        advanced
        :class="`${el}__input`"
        :checked="dependentPerson === 'other'"
        @input="onChange('other')"
        tabindex="0"
        @keyup.enter.native="onChange('other')"
        @keyup.space.native="onChange('other')"
        role="radio"
        :aria-checked="dependentPerson === 'other'"
      />

      <Button
        slot="4"
        :href="href"
        :class="`${el}__stepButton`"
        :label="$t('intro.step3.button')"
        :disabled="!dependentPerson"
        small
        @click="() => $emit('onTrackingClick', '_btn-' + $t('intro.step3.button'), 'button')"
      />

      <Illustration
        slot="5"
        :class="`${el}__illustration`"
        name="teaser-6"
        :brush="6"
        :brushScale="0.7"
        noLazy
      />
    </InViewAnimation>
  </div>
</template>

<script>
import Button from '@/objects/Button';
import Headline from '@/objects/Headline';
import Illustration from '@/objects/Illustration';
import BaseRadio from '@/objects/Forms/BaseRadio';
import InViewAnimation from '@/components/InViewAnimation';

import { mapFieldsHealth } from '@/store/mapFields';

import { HEALTH_SET_DEPENDENT_PERSON } from '@/store/actions/health';

export default {
  name: 'Step3',
  props: {
    el: String,
    href: String,
  },
  components: {
    Button,
    Headline,
    Illustration,
    BaseRadio,
    InViewAnimation,
  },
  computed: {
    ...mapFieldsHealth(['dependentPerson']),
  },
  data() {
    return {};
  },
  methods: {
    onChange(type) {
      this.$store.dispatch(HEALTH_SET_DEPENDENT_PERSON, type);
    },
  },
};
</script>
